import {RowItem} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/RowItem";
import {ColumnItemOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/TableControl.Options";
import {FieldControl} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl";
import {PDFControlGenerator} from "InternalShared/PageBuilder/Controls/Core/Generators/PDFControlGenerator";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {HTMLUtils} from "PageBuilder/utils/HTMLUtils";
import {FieldItemBase} from "InternalShared/PageBuilder/Fields/FieldItemBase";
import {ColumnBehavior} from "PageBuilder/pagebuilder/Controls/Behaviors/ColumnBehavior";
import {EventManager} from "shared/utilities/Events/EventManager";
import {OpenProperties} from "PageBuilder/Events/OpenProperties";

export class ColumnItem {
    public Column:HTMLTableDataCellElement;
    public Fields:PDFControlBase[];
    public EmptyMessage:HTMLElement;

    public OriginalPosition:{x:number,y:number};
    public IsResizeDragging;
    public ResizePosition:''|'first'|'second';
    public InitialResizeData:{x:number,y:number,firstElementWidth:number,secondElementWidth:number,firstElement:ColumnItem,secondElement:ColumnItem};
    constructor(public RowItem:RowItem,public Options:ColumnItemOptions)
    {
        this.Fields=[];
        this.IsResizeDragging=false;
        this.OnMouseDown=this.OnMouseDown.bind(this);
        this.DraggingMove=this.DraggingMove.bind(this);
        this.OnMouseUp=this.OnMouseUp.bind(this);
        this.OnMouseMove=this.OnMouseMove.bind(this);
        this.ResizeMove=this.ResizeMove.bind(this);
        this.OnDragEnter=this.OnDragEnter.bind(this);
        this.OnDragLeave=this.OnDragLeave.bind(this);
        this.OnDrop=this.OnDrop.bind(this);
    }

    async OnDrop(e)
    {
        this.Column.classList.remove('dragzone');
        e.stopPropagation();

        let type=e.dataTransfer.getData('Text');
        let field:PDFControlBase=PDFControlGenerator.GetControl(this.RowItem.TableItem.TableControl.Page,type);

        let pageX=e.pageX;
        let pageY=e.pageY;
        this.Column.innerHTML='';
        let result=await (field as PDFControlBase).InitializeWithContainer(this.RowItem.TableItem.TableControl.Page, this.Column,new ColumnBehavior(this));
        field.Options.Styles.Width='100%';
        this.Fields.push(field);
        this.Options.Fields.push(field.Options);
    }

    OnMouseMove(e)
    {
        if(this.IsResizeDragging)
            return;
        let rect=this.Column.getBoundingClientRect();
        let x=e.pageX-rect.left;

        this.Column.style.cursor='';
        if(!this.IsLastColumn)
            if(x>=rect.width-4){
                this.Column.style.cursor='col-resize';
                this.ResizePosition='first';
            }


        if(!this.IsFirstColumn)
            if(x<=2){
                this.Column.style.cursor='col-resize';
                this.ResizePosition='second';
            }




    }

    OnMouseUp(e)
    {
        document.removeEventListener('mousemove',this.ResizeMove);
        document.removeEventListener('mousemove',this.DraggingMove);
        document.removeEventListener('mouseup',this.OnMouseUp);


        document.body.style.setProperty('cursor','');
        this.IsResizeDragging=false;

    }

    OnDragEnter(e){
        this.Column.classList.add('dragzone');
        console.log('over');

    }


    OnDragLeave(e){
        this.Column.classList.remove('dragzone');
        console.log('dragleave',e.target);
    }

    OnMouseDown(e){
        this.OriginalPosition={
            x:e.pageX,
            y:e.pageY
        };
        if(this.Column.style.cursor=='col-resize')
        {
            this.ResizeDrag(e);
            return;
        }

        this.RowItem.TableItem.SelectColumn(this);
        document.addEventListener('mouseup',this.OnMouseUp);
        document.addEventListener('mousemove',this.DraggingMove);
    }

    Generate(container:HTMLTableDataCellElement=null) {
        if(this.Column==null)
        {
            if(container!=null)
                this.Column=container;
            else {
                this.Column = document.createElement('td');
                this.RowItem.Row.appendChild(this.Column);
            }

            this.Column.addEventListener('mousemove',this.OnMouseMove);
            this.Column.addEventListener("dragover",this.OnDragEnter);
            this.Column.addEventListener("dragleave",this.OnDragLeave);
            this.Column.addEventListener("drop",this.OnDrop);
        }

        this.Column.style.width=this.Options.Width+'%';

        this.Fields=[];


        this.Column.addEventListener('mousedown',this.OnMouseDown);




        for(let field of this.Options.Fields)
        {
            let currentField=PDFControlGenerator.GetControl(this.RowItem.TableItem.TableControl.Page,field.Type);
            this.Column.innerHTML='';
            currentField.InitializeWithContainer(this.RowItem.TableItem.TableControl.Page,this.Column,new ColumnBehavior(this),field);
            this.Fields.push(currentField);
        }


        if(this.Fields.length==0)
        {
            let message=document.createElement('p');
            message.className='emptyMessage';
            message.innerText='Drop a field here';
            this.Column.appendChild(message);
        }
    }

    Remove() {
        this.Column.removeEventListener('mousedown',this.OnMouseDown);
        this.Column.remove();
    }

    private DraggingMove(e:MouseEvent) {
        let dragSquarePosition=[];
        let initialPosition:{x:number,y:number}={
            x:this.OriginalPosition.x,
            y:this.OriginalPosition.y
        };

        let endPosition:{x:number,y:number}={
            x:e.pageX,
            y:e.pageY
        };

        if(initialPosition.x>endPosition.x)
        {
            let aux=initialPosition.x;
            initialPosition.x=endPosition.x;
            endPosition.x=aux;
        }

        if(initialPosition.y>endPosition.y){
            let aux=initialPosition.y;
            initialPosition.y=endPosition.y;
            endPosition.y=aux;
        }

        let squarePosition=[
            [initialPosition.x,initialPosition.x+(endPosition.x-initialPosition.x)],
            [initialPosition.y,initialPosition.y+(endPosition.y-initialPosition.y)]
            ];


        for(let row of this.RowItem.TableItem.RowItems)
            for(let column of row.ColumnItems)
            {
                let pos, width, height;
                pos = HTMLUtils.GetOffset(column.Column);
                width = $(column.Column).width();
                height = $(column.Column).height();
                let elementPosition= [ [ pos.left, pos.left + width ], [ pos.top, pos.top + height ] ];

                //hittest
                if(this.ComparePositions( squarePosition[0], elementPosition[0] ) && this.ComparePositions( squarePosition[1], elementPosition[1] )){
                    this.RowItem.TableItem.SelectColumn(column,false);
                }else{
                    this.RowItem.TableItem.DeselectColumn(column);
                }

            }



    }

    public get IsFirstColumn(){
        return this.RowItem.ColumnItems.indexOf(this)==0;
    }

    public get IsLastColumn(){
        return this.RowItem.ColumnItems.indexOf(this)==this.RowItem.ColumnItems.length-1;
    }

    private ComparePositions( p1, p2 ) {
        var r1, r2;
        r1 = p1[0] < p2[0] ? p1 : p2;
        r2 = p1[0] < p2[0] ? p2 : p1;
        return r1[1] > r2[0] || r1[0] === r2[0];
    }

    SetWidth(width: number) {
        this.Options.Width=width;
        this.Column.style.width=width+'%';
    }

    private ResizeDrag(e: any) {
        let firstElement:ColumnItem=null;
        let secondElement:ColumnItem=null;

        if(this.ResizePosition=="first")
        {
            firstElement=this;
            let index=this.RowItem.ColumnItems.indexOf(this);
            secondElement=this.RowItem.ColumnItems.length>index+1?this.RowItem.ColumnItems[index+1]:null;
        }else{
            secondElement=this;
            let index=this.RowItem.ColumnItems.indexOf(this);
            firstElement=index-1>=0?this.RowItem.ColumnItems[index-1]:null;
        }

        if(firstElement==null||secondElement==null)
            return;

        this.InitialResizeData={
            x:e.pageX,
            y:e.pageY,
            firstElementWidth:firstElement.Options.Width,
            secondElementWidth:secondElement.Options.Width,
            firstElement:firstElement,
            secondElement:secondElement


        };
        document.body.style.setProperty('cursor','col-resize','important');
        document.addEventListener('mousemove',this.ResizeMove);
        document.addEventListener('mouseup',this.OnMouseUp);
        this.IsResizeDragging=true;
    }

    public ResizeMove(e){
        let delta=this.InitialResizeData.x-e.pageX;
        let deltaPercentage=Math.floor(delta*100/this.RowItem.Row.getBoundingClientRect().width);

        let fieldToRemoveWidth:number=null;
        if(deltaPercentage>0)
            fieldToRemoveWidth=this.InitialResizeData.firstElementWidth;
        else
            fieldToRemoveWidth=this.InitialResizeData.secondElementWidth;

        if(fieldToRemoveWidth-deltaPercentage<2)
        {
            deltaPercentage=fieldToRemoveWidth-2;
        }


        this.RowItem.TableItem.SetColumnWidth(this.InitialResizeData.firstElement,this.InitialResizeData.firstElementWidth-deltaPercentage);
        this.RowItem.TableItem.SetColumnWidth(this.InitialResizeData.secondElement,this.InitialResizeData.secondElementWidth+deltaPercentage);


    }

    Select() {
        if(this.Fields.length>0) {
            this.Fields[0].Select();
            EventManager.Publish(new OpenProperties(this.Fields[0]));
        }
    }

    Highlight() {
        this.Column.classList.add('selected');
    }

    UnHighlight() {
        this.Column.classList.remove('selected');
    }

    DeleteFields() {
        this.Options.Fields=[];
        this.Column.innerHTML='';
        let message=document.createElement('p');
        message.className='emptyMessage';
        message.innerText='Drop a field here';
        this.Column.appendChild(message);
        this.Fields=[];
    }
}